import BaseListPresenter from "../../base/BaseListPresenter";

class CalendarCoordinatorPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async getAllEvents(currentUser) {
    const collection = "calendar";
    try {
      console.log("Fetching events from collection:", collection);

      // Create a query to filter events by coordinator.id
      const query = {
        where: { "coordinator.id": currentUser.id }, // Filter by the current user's ID
      };

      console.log("Filtering events for coordinator:", currentUser.id);
      const events = await this.findObjectUseCase.execute(collection, query);

      console.log("Events retrieved for current user:", events);

      // Ensure all events have a startDate
      const eventMap = {};
      events.forEach((event) => {
        if (!event.startDate) {
          console.warn("Event missing startDate:", event);
          return; // Skip events without a valid date
        }

        // Format the date key to match the Calendar component's expected format
        // Convert the startDate string to a Date object
        const eventDate = new Date(event.startDate);
        const dateKey = `${eventDate.getFullYear()}-${
          eventDate.getMonth() + 1
        }-${eventDate.getDate()}`;

        if (!eventMap[dateKey]) {
          eventMap[dateKey] = [];
        }

        // Ensure all required properties exist
        eventMap[dateKey].push({
          ...event,
          endDate: event.endDate || event.startDate, // Default endDate to startDate if not provided
          startTime: event.startTime || "00:00",
          endTime: event.endTime || "23:59",
        });
      });

      return eventMap;
    } catch (error) {
      console.error("Error fetching events:", error);
      return {};
    }
  }

  async handleSubmit(eventData) {
    const collection = "calendar";

    if (!eventData || !eventData.description) {
      console.error("Invalid event data:", eventData);
      return;
    }

    // Ensure an ID exists
    if (!eventData.id) {
      eventData.id = new Date().getTime();
    }

    try {
      await this.upsertUseCase.execute(collection, eventData);
      this.view.successModal("Data has been successfully saved.");
    } catch (error) {
      console.error("Error in upsertUseCase:", error);
    }
  }

  async deleteEvent(eventId) {
    const collection = "calendar";

    if (!eventId) {
      console.error("Missing event ID for deletion");
      return;
    }

    try {
      console.log("Deleting event with ID:", eventId);
      await this.deleteObjectUseCase.execute(collection, eventId);
      console.log("Event deleted successfully.");
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  }

  onClickAdd() {
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickView(empDetails) {
    // Assuming the coordinator ID is available in empDetails.id
    const coordinatorId = empDetails.id;
    this.view.navigateTo(`/me/recruiter/calendar/${coordinatorId}`);
  }

  onChangeReference(value, schema) {
    console.log("VV", value);
    this.reset();
    this.filter = {
      referenceNumber: { $regex: value, $options: "i" },
    };
    this.getObjects();
  }
}

export default CalendarCoordinatorPagePresenter;
